import { cn } from "@/lib/utils";
import {
  verdictLabel,
  type VerdictRating,
} from "@/components/experience/vocabulary";

interface StateLineProps {
  scenarioId: string | null;
  runCount: number;
  openCount: number;
  criticalCount: number;
  latestRating: VerdictRating | null;
}

export function StateLine({
  scenarioId,
  runCount,
  openCount,
  criticalCount,
  latestRating,
}: StateLineProps) {
  if (!scenarioId) {
    return <span className="text-sm text-muted-foreground">Loading…</span>;
  }
  if (runCount === 0) {
    return <span className="text-sm text-muted-foreground">Not run yet</span>;
  }

  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-1.5 gap-y-1 text-sm tabular-nums text-muted-foreground">
      <span>
        {runCount} {runCount === 1 ? "run" : "runs"}
      </span>
      {openCount > 0 && (
        <>
          <span aria-hidden="true">·</span>
          <span
            className={cn(
              criticalCount > 0 ? "text-destructive" : "text-foreground",
              "font-semibold",
            )}
          >
            {openCount} open
          </span>
        </>
      )}
      {criticalCount > 0 && (
        <>
          <span aria-hidden="true">·</span>
          <span className="font-semibold text-destructive">
            {criticalCount} critical
          </span>
        </>
      )}
      {latestRating && (
        <>
          <span aria-hidden="true">·</span>
          <span>
            latest:{" "}
            <span className="font-semibold text-foreground">
              {verdictLabel(latestRating)}
            </span>
          </span>
        </>
      )}
    </span>
  );
}
